import $ from 'jquery';
import { queryString, redirectWithParams } from '@/js/modules/query_params';
import { INLINE_SELECTIZE } from '@/js/modules/selectize_plugins';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).ready(function () {
    $('.filter-container--designer-projects .filter-dropdown__field')
      .selectize({
        plugins: [INLINE_SELECTIZE],
        render: {
          item(data, escape) {
            return `<div class="field__tag-item">${escape(data.text)}</div>`;
          },
        },
      })
      .on('change', function (e) {
        const $filterElement = $(e.currentTarget);

        // only apply filter when user manually selects the filter and not when "enter" key is pressed
        // on the page randomly
        if (!$filterElement.parents('.filter-list__item').hasClass('filter-list__item--open')) {
          this.selectize && this.selectize.clear();
          return false;
        }

        const params = queryString();
        const param = $filterElement.data('param');
        params[param] = $filterElement.val();

        if (!params[param]) {
          return false;
        }
        if (params[param] === 'all') {
          delete params[param];
        }
        delete params['page'];
        redirectWithParams(params);
      });

    $('#designer-projects').on('click', (e) => {
      const $dropdown = $(e.target).closest('.filter-list__item');
      if (!$dropdown.length && $('.filter-list__item').hasClass('filter-list__item--open')) {
        $('.filter-list__item').removeClass('filter-list__item--open');
      }
    });
  });
});
